/**
* @author 张雨生 2020-08-26
* 功能: 解说内容页面的展示与数据操作
*/
<template lang="pug">
  .commentary
    el-header
      el-form(:inline="true" :size="GLOBAL.SIZE_OF_INPUTBOX" @submit.native.prevent)
        el-form-item
          el-input.search(v-model="queryParams.keywords" placeholder='请输入标题或者编号查询数据' clearable :size="GLOBAL.SIZE_OF_INPUTBOX")
            el-button(slot="append" icon="el-icon-search" @click="getPage")
        el-form-item(label="状态")
          el-select.filter(v-model="queryParams.status" multiple placeholder="请选择" :size="GLOBAL.SIZE_OF_INPUTBOX" @change="getPage")
            el-option(
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value")
        el-form-item(label="限免")
          el-checkbox-group(v-model='queryParams.freeStatus' @change="getPage")
            el-checkbox(label='isfree') 是
            el-checkbox(label='nofree')  否
        el-form-item
          el-button(v-if="hasEditAuth" type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="showCommentaryDialog()") 添加
    el-main
      el-table(:data="list" style="width: 100%" v-loading="loading")
        //- el-table-column(label="编号" prop="_id" show-overflow-tooltip fixed)
        el-table-column(label="头图" prop="image" align="center" width="60" fixed)
          template(slot-scope="scope")
            img(v-if='scope.row.image' :src="scope.row.image" style="max-width:100px;max-height:40px;")
        el-table-column(label="标题" prop="title" show-overflow-tooltip fixed)
        //- el-table-column(label="行业" prop="industry")
        //-   template(slot-scope="scope")
        //-     span(v-if="scope.row.industry" v-html="scope.row.industry.join('<br />')")
        el-table-column(label="时长" prop="duration")
          template(slot-scope="scope")
            p {{ scope.row.duration | durationFilter }}
        el-table-column(label="关联报告" prop="reportName" show-overflow-tooltip)
        el-table-column(label="状态" prop="status" width="100" align="center")
          template(slot-scope="scope")
            p {{ scope.row.status | status }}
        el-table-column(label="限免" prop="free" width="50")
          template(slot-scope="scope")
            i.el-icon-check(v-if='scope.row.free')
            i.el-icon-close(v-else)
        el-table-column(label="转码" prop="transcodeStatus" width="80")
          template(slot-scope="scope")
            p {{ scope.row.transcodeStatus | transcode }}
        el-table-column(label="创作者" prop="author" width="120" align="center")
        el-table-column(label="更新用户" prop="status" width="80" align="center")
          template(slot-scope="scope")
            p {{ scope.row.updatedByName || '暂无' }}
        el-table-column(label="类型" prop="type" width="80" align="center")
          template(slot-scope="scope")
            p {{scope.row.type | videoType}}
        el-table-column(label="更新时间" prop="updatedAt" width="140" align="center")
          template(slot-scope="scope")
            p {{scope.row.updatedAt | changeData}}
        el-table-column(label="操作" width="300" align="center")
          template(slot-scope="scope")
            el-button-group
              el-button(title='预览' round size='mini' icon='el-icon-view' type='primary' @click='play(scope.row.vid)')
              el-button(v-if="hasEditAuth" title="编辑" round icon="el-icon-edit" size="mini" type="info" @click="showCommentaryDialog(scope.row)")
              el-button(title="删除" round icon="el-icon-delete" v-if="scope.row.status !== 2 && hasReviewAuth" size="mini" type="danger" @click="handleDeleteCommentary(scope.row)")
              template(v-if="scope.row.status !== 1")
                review(:single.sync="scope.row" url="/video/review")
              template(v-else-if="hasReviewAuth")
                review(ref="successReview" :single.sync="scope.row" title="通过" type='video' url="/video/review" @sensitive="handleSensitive")
                review(:single.sync="scope.row" title="驳回" url="/video/review")
              el-button(v-if="hasEditAuth" title="更新数据" round icon="el-icon-refresh" size="mini" type="success" @click="refreshSingle(scope.row, scope.$index)")
      el-pagination.pagination(
        background
        @current-change="handleCurrentChange"
        :current-page="queryParams.currentPage"
        :page-size="GLOBAL.pageSize"
        layout="total, prev, pager, next"
        :total="total")
    commentary-dialog(ref="commentaryDialog" @create="handleCreateCommentary" @update="handleUpdateCommentary" @close="handleClose")
    play-dialog(ref="playDialog")
    el-dialog(title='敏感词检测' :visible.sync='isShowSensitiveDialog' width='800px')
      el-row(style='overflow: hidden')
        el-table(:data='currentSensitive' style='width: 100%')
          el-table-column(prop='key' label='类型' width='100')
          el-table-column(prop='error' label='错误' show-overflow-tooltip)
            template(slot-scope='scope')
              span(v-html="scope.row.error.join('<br />')" )
        el-button(type='primary' size='small' style='float: right; margin-top: 20px' @click='close') 前往修改
        el-button(size='small' style='float: right; margin-top: 20px; margin-right: 20px' @click='handleReview()') 仍然提交
</template>

<script>
import passport from '@/javascripts/passport'

import { createCommentary, getCommentaryPage, deleteCommentary, updateCommentary, fileUploadComplete, detail, getTransCode } from '@/apis/video'
import commentaryDialog from './components/dialog'
import playDialog from './components/play'
import Review from '@/components/Review'
import { parseTime, timeTohhmmss } from '@/javascripts/time'
import Enum from '@/apis/enum'

export default {
  name: 'Commentary',
  components: { commentaryDialog, Review, playDialog },
  data () {
    return {
      headers: passport.headers(),
      options: Enum.STATUS,
      loading: false,
      list: [],
      total: 0,
      queryParams: {
        keywords: '',
        currentPage: 1,
        freeStatus: ['isfree', 'nofree']
      },
      isShowSensitiveDialog: false,
      currentSensitive: []
    }
  },
  created () { this.getPage() },
  computed: {
    hasEditAuth () {
      return passport.checkAuth([Enum.AUTH.VIDEO_REVIEW, Enum.AUTH.VIDEO_EDIT])
    },
    hasReviewAuth () {
      return passport.checkAuth([Enum.AUTH.VIDEO_REVIEW])
    }
  },
  filters: {
    changeData: function (val) {
      if (!val) {
        return '暂无日期'
      }
      var date = new Date(val)
      return parseTime(date, '{y}-{m}-{d} {h}:{i}')
    },
    durationFilter: function (val) {
      if (!val) {
        return '暂无'
      }
      return timeTohhmmss(val)
    },
    transcode: function (val) {
      return val ? '转码成功' : val === false ? '转码失败' : '转码中…'
    }
  },
  methods: {
    close () {
      this.isShowSensitiveDialog = false
    },
    handleSensitive (data) {
      this.currentSensitive = data
      this.isShowSensitiveDialog = true
    },
    handleReview () {
      this.$refs.successReview.handleReview()
      this.close()
    },
    // 关闭dialog
    handleClose () {
      this.$refs.commentaryDialog.dialogVisible = false
    },
    // 显示dialog(更新操作会传递数据)
    showCommentaryDialog (data = {}) {
      data = JSON.parse(JSON.stringify(data))
      this.$refs.commentaryDialog.show(data)
    },
    // 创建解说数据
    handleCreateCommentary (data) {
      createCommentary(data).then(res => {
        if (res.errCode !== 0) {
          return this.$message({ type: 'error', message: '创建解说失败: ' + res.msg })
        }
        if (data.vid) fileUploadComplete({ videoId: data.vid })
        this.$message({ type: 'success', message: '创建解说成功！' })
        this.getPage()
        this.handleClose()
      }).catch(err => {
        this.$message({ type: 'error', message: err })
      })
    },
    // 更新解说数据
    handleUpdateCommentary (data) {
      detail({ id: data._id }).then(res => {
        if (res.errCode === 0) {
          if (data.vid && res.data.vid !== data.vid) {
            fileUploadComplete({ videoId: data.vid })
          }
        }
        updateCommentary(data).then(res => {
          if (res.errCode !== 0) {
            return this.$message({ type: 'error', message: '更新解说失败: ' + res.msg })
          }
          this.$message({ type: 'success', message: '更新解说成功！' })
          this.getPage()
          this.handleClose()
        }).catch(err => {
          this.$message({ type: 'error', message: err })
        })
      })
    },
    // 删除解说数据
    handleDeleteCommentary (row) {
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        deleteCommentary({ _id: row._id, videoId: row.vid }).then(res => {
          if (res.errCode !== 0) {
            return this.$message({ type: 'error', message: '删除解说失败: ' + res.msg })
          }
          this.$message({ type: 'success', message: '删除解说成功！' })
          this.getPage()
        }).catch(err => {
          this.$message({ type: 'error', message: err })
        })
      }).catch(() => { })
    },
    // 获取解说数据
    getPage () {
      this.loading = true
      getCommentaryPage(this.queryParams).then(res => {
        if (res.errCode !== 0) {
          return this.$message({ type: 'error', message: '获取解说数据失败!' })
        }
        this.list = res.data.data
        this.total = res.data.count
        this.loading = false
      }).catch(err => {
        this.$message({ type: 'error', message: err })
      })
    },
    // 翻页
    handleCurrentChange (pageNo) {
      this.queryParams.currentPage = pageNo
      this.getPage()
    },
    // 上传头图
    uploadedImage (result) {
      if (result.errCode === 0) {
        const index = this.list.findIndex(item => item._id === result.data._id)
        this.$set(this.list[index], 'image', result.data.url)
      } else {
        this.$emit({ type: 'error', message: '上传图片失败！' })
      }
    },
    // 打开播放弹框 播放解说视频
    play (vid) {
      this.$refs.playDialog.show(vid)
    },
    // 再次查询转码状态
    refreshSingle (row, index) {
      if (row.vid) {
        getTransCode({ vid: row.vid }).then(res => {
          if (res.errCode === 0) {
            this.$set(this.list[index], 'transcodeStatus', res.data)
            this.$message({ type: 'success', message: res.data === true ? '转码成功' : res.data === false ? '转码失败' : '正在转码' })
          } else {
          }
        })
      } else {
        this.$emit({ type: 'error', message: '没有视频vid，请重新上传视频' })
      }
    }
  }
}
</script>

<style>
.commentary .el-main,
.commentary .el-header {
  padding: 0;
}
</style>